export default [
  { key: '1', label: 'Sequencing Platform',type: 'text',name: 'sequencingPlatform',required: true },
  { key: '2', label: 'Variant Caller',type: 'text',name: 'variantCaller',required: true },
  { key: '3', label: 'Reagent Kit', type: 'text', name: 'reagentKit', required: true },
];


